var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var BannerLevel = /* @__PURE__ */ ((BannerLevel2) => {
  BannerLevel2[BannerLevel2["success"] = 1] = "success";
  BannerLevel2[BannerLevel2["info"] = 2] = "info";
  BannerLevel2[BannerLevel2["warning"] = 3] = "warning";
  BannerLevel2[BannerLevel2["danger"] = 4] = "danger";
  return BannerLevel2;
})(BannerLevel || {});
class BannerService {
  constructor() {
    __publicField(this, "_sink");
  }
  addBanner(banner) {
    var _a;
    (_a = this._sink) == null ? void 0 : _a.addBanner(banner);
  }
  addMultipleBanners(banners, prefix) {
    var _a;
    (_a = this._sink) == null ? void 0 : _a.addMultipleBanners(banners, prefix);
  }
  removeBanner(name) {
    var _a;
    (_a = this._sink) == null ? void 0 : _a.removeBanner(name);
  }
  removeBannerWithPrefix(prefix) {
    var _a;
    (_a = this._sink) == null ? void 0 : _a.removeBannerWithPrefix(prefix);
  }
  setBannerSink(sink) {
    this._sink = sink;
  }
}
const BannerService$1 = new BannerService();
export {
  BannerLevel,
  BannerService,
  BannerService$1 as default
};
//# sourceMappingURL=BannerService.js.map
